import { render } from "./ItemSizeView.vue?vue&type=template&id=476d5a46"
import script from "./ItemSizeView.vue?vue&type=script&lang=js"
export * from "./ItemSizeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__